module.exports = __webpack_public_path__ + "static/media/Tick.77091c82.png";